module.exports = __webpack_public_path__ + "static/media/online-chart.5ea5df6d.svg";